export function getText(entry) {
  return entry.previous_collection_label_template
    ? `${entry.previous_collection_label_template.name} added`
    : 'Collection label deleted'
}
